import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { LocationInfoMap } from '@fcom/dapi';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairItineraryItemFlight } from '@fcom/dapi/api/models/finnair-itinerary-item-flight';
import { FinnairPassengerItem } from '@fcom/dapi/api/models/finnair-passenger-item';
import { ButtonTheme } from '@fcom/ui-components';

const MAX_EXEC_TIMES = 20;

@Component({
  selector: 'fin-ancillary-flight-bound-selector',
  templateUrl: 'ancillary-flight-bound-selector.component.html',
  styleUrls: ['ancillary-flight-bound-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AncillaryFlightBoundSelectorComponent {
  readonly ButtonTheme = ButtonTheme;

  @Input()
  boundsOrFlights: Array<FinnairBoundItem | FinnairItineraryItemFlight>;

  @Input()
  activeBoundIndex = 0;

  @Input()
  locations: LocationInfoMap;

  @Input()
  passengers: FinnairPassengerItem[];

  @Output()
  selectIndex: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  viewDetails: EventEmitter<void> = new EventEmitter<void>();

  onChangeFlightBound(index: number, addition: number, execTimes = 0): void {
    const indexToGo =
      index < 0 ? this.boundsOrFlights.length - 1 : index <= this.boundsOrFlights.length - 1 ? index : 0;
    const boundOrFlight = this.boundsOrFlights[indexToGo];
    if (boundOrFlight) {
      this.selectIndex.emit(indexToGo);
      return;
    }

    if (execTimes < MAX_EXEC_TIMES) {
      this.onChangeFlightBound(indexToGo + addition, addition, execTimes + 1);
    }
  }
}
